module.exports = __webpack_public_path__ + "img/fig13.fc779262.jpg";